import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowNextSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 6.414 10.586 12 5 17.586 6.414 19l7-7-7-7L5 6.414Zm5.586 0L16.172 12l-5.586 5.586L12 19l7-7-7-7-1.414 1.414Z"
    />
  </svg>
);
export default IconArrowNextSizeM;
